import React from 'react';
import { motion } from 'framer-motion';
export function HookSection() {
  return <section className="py-24 bg-[#0d0d14] bg-noise relative border-t border-tactical-800/50" data-id="element-30">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-31">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="space-y-8 text-lg md:text-xl text-gray-300 leading-relaxed" data-id="element-32">
          <p data-id="element-33">
            Mira a tu alrededor por un segundo. Tu apartamento es cómodo, tu
            cuenta bancaria tiene ahorros y tu familia duerme tranquila. Pero en
            el fondo, en ese lugar incómodo de tu mente, sabes que la
            "normalidad" urbana pende de un hilo.
          </p>

          <p data-id="element-34">
            Has visto las noticias. Has sentido cómo la inflación devora el
            poder de compra. Has notado cómo eventos climáticos extremos
            paralizan ciudades enteras en horas.
          </p>

          <div className="pt-8 pb-4" data-id="element-35">
            <p className="text-2xl md:text-3xl font-heading font-semibold text-white leading-tight border-l-4 border-cyan-accent pl-6 py-2 bg-gradient-to-r from-cyan-accent/10 to-transparent" data-id="element-36">
              La pregunta no es si el sistema va a parpadear... la pregunta es:{' '}
              <br data-id="element-37" />
              <span className="text-cyan-accent text-glow-cyan mt-2 block" data-id="element-38">
                ¿Estás preparado para los primeros 30 minutos de oscuridad
                total?
              </span>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}